const Form040EN = {
    stepName: {
        importantNotes: "Important Notes",
        basicInformation: "Basic Information",
        maximumCapacity: "Maximum Capacity",
        childrenServed: "Children Served",
        currentStaffStrength: "Current Staff Strength",
        existingFacilities: "Existing Facilities",
        confirmation: "Confirmation",
    },

    importantNotes: {
        p_importantNotes: "Important Notes",
        p_importantNotes_one:
            "Applicant without an “iAM Smart+” account is required to return the completed form to Joint Office for Kindergartens and Child Care Centres for processing (Address: Room 602, 6/F, 14 Taikoo Wan Road, Taikoo  Shing,  Hong  Kong).Please  ensure  that  sufficient  postage  is  paid  to  avoid  unsuccessful delivery. Any underpaid mail items will be disposed of by the Hongkong Post.",
        p_title: "Personal Information Collection Statement",

        p_title_one: "<u>Purpose of Collection</u>",
        p1_1: "The personal data provided by you in this form will be used by the EDB for one or more of the following purposes:",
        p1_a: "Activities relating to the processing, authentication and counter-checking of the Application for Adjustment in Capacity in Kindergarten-cum-Child Care Centre (KG-cum-CCC) / CCC Section of KG-cum-CCC including appointments, training and career developments, remuneration and benefits, staff relation, communications and compliance with procedures;",
        p1_b: "Activities relating to matching of the personal data with the database of other relevant Government bureaux / departments in connection with the processing, authentication and counter-checking of the application mentioned in (a) above;",
        p1_c: "Activities relating to matching of the personal data within the database of EDB for purposes of verifying / updating records of the EDB;",
        p1_d: "Activities relating to training and development including invitation of participation in programmes / activities, applications for reimbursement of course fees, assessment of nominations, awards and scholarship, and monitoring of attainment progress;",
        p1_e: "Activities relating to the processing and vetting of applications for, and disbursement of, funding / grants / subsidies, and conducting of audits;",
        p1_f: "Activities relating to compilation of statistics, research and Government publications; and",
        p1_g: "Activities relating to the administration and enforcement of rules and regulations including the Education Ordinance (Cap. 279), its subsidiary legislation (such as the Education Regulations and the Grant/Subsidized Schools Provident Fund Rules); and the Codes of Aid, the Child Care Services Ordinance (Cap.243) and its subsidiary legislation (i.e., the Child Care Services Regulations (Cap 243 A) )",
        p2: "The provision of personal data required by this form and during the processing of this form is obligatory.  In the event that you do not provide those personal data, we may not be able to handle or further process the application.",

        p_title_two: "<u>Classes of Transferees</u>",
        p3: "The personal data you provide will be made available to persons working in EDB.  Apart from this, they may be transferred or disclosed to the parties or in the circumstances listed below:-",
        p3_a: "other Government bureau and departments for the purposes mentioned in paragraph 1 above;",
        p3_b: "personnel, agent, service provider or organizations, engaged by EDB to provide services or advice for the purposes mentioned in paragraph 1 above;",
        p3_c: "where you have given your prescribed consent to such disclosure; and",
        p3_d: "where such disclosure is authorised or required under the law or court order applicable to Hong Kong.",

        p_title_three: "<u>Access to Personal Data</u>",
        p4: "You have the right to request access to and correction of your personal data held by EDB.  Request for access or correction of personal data should be made in writing to intake officer at Room 602, 6/F, 14 Taikoo Wan Road, Taikoo Shing, Hong Kong or email to ",
    },
    // importantNotes: {
    //     p_title: "Personal Information Collection Statement",
    //     p1_1: "The personal data provided in this form will be used by the Education Bureau for one or more of the following purpose(s): ",
    //     p1_a: "auditing;",
    //     p1_b: "conducting research and compiling statistics to facilitate planning of pre-primary education services;",
    //     p1_c: "processing matters relating to the development of the pre-primary education profession;",
    //     p1_d: "processing matters relating to the operation of pre-primary institutes;",
    //     p1_e: "administering and enforcing the Education Ordinance and Regulations, and the Child Care Services Ordinance (Cap. 243) and Regulations (Cap. 243A).",

    //     p2: "The provision of personal data by means of this form is obligatory.  Failure to provide these data may affect the processing and outcome of your application. ",
    //     p3: "The personal data collected in this form may be disclosed to other government bureau/departments/agencies authorized to process such information for the purposes mentioned above. ",
    //     p4: "You have a right to request access to and correction of your personal data as provided in Sections 18 and 22 and Data Protection Principle 6 of Schedule 1 of the Personal Data (Privacy) Ordinance.  Your right of access includes the right to obtain a copy of your personal data provided in this form.  This is however subject to payment of a fee. ",
    //     p5: "Enquiries concerning the personal data collected by means of this form, including making of access and corrections, should be made in writing to Education Bureau.",
    // },

    childrenAgeOption: {
        zeroThreeYears: "0-3 years",
        twoThreeYearsStepThree: "2-3 years",
        zeroSixYears: "0-6 years",
        twoSixYearsStepThree: "2-6 years",
    },
    workingHoursOption: {
        AmAndPm: "AM+PM",
        Am: "AM",
        Pm: "PM",
        Other: "Other working hours",
    },
    FirstAidTrainingOption: {
        yes: "Yes",
        no: "No",
    },
    operatorTypeOption: {
        operator: "Operator",
        centreSupervisor: "Centre Supervisor",
        kindergartenPrincipal: "Kindergarten Principal",
    },
    label: {
        applicantAddress: "Applicant's Address",
        nameOfKgCumCcc: "Name of KG-cum-CCC",
        addressOfKgCumCcc: "Address of KG-cum-CCC",
        maximumCapacity: "(A) (i) Maximum Capacity",
        existingApprovedCapacity: "(ii) Existing Approved Capacity",
        proposedCapacityAfterAdjustment:
            "(iii) Proposed Capacity after Adjustment",
        childrenServed: "(B) Children Served-Year Range (single select)",
        zeroTwoYears: "Max capacity (0-2 years)",
        twoThreeYears: "Max capacity (2-3 years)",
        twoSixYears: "Max capacity (2-6 years)",
        currentStaffStrength: "(C) Current Staff Strength",
        zeroThreeYears: "(i) 0-3 years",
        twoThreeYearsStepThree: "(ii) 2-3 years",
        zeroSixYears: "(iii) 0-6 years",
        twoSixYearsStepThree: "(iv) 2-6 years",
        proposedCapacityAfterAdjustmentWef:
            "Proposed Capacity after Adjustment w.e.f.",
        name: "Name",
        hKid: "HKID No.",
        passport: "Passport No.",
        hkidOrPassport: "HKID No./Passport No.",
        post: "Post",
        ccsInclusion: "CCS Inclusion No.",
        ccwInclusion: "CCW Inclusion No.",
        ccsOrCCwInclusion: "CCS Inclusion No./CCW Inclusion No.",
        rtNo: "RT No.",
        ptNo: "valid PT No.",
        rtptNoType: "RT No./valid PT No.",
        workingHours: "Working Hours",
        otherWorkingHours: "Please specify",
        firstAidCertNo: "Valid First Aid Cert No.",
        firstAidCertValidDate: "First Aid Certificate Valid on",
        firstAidCertExpireDate: "First Aid Certificate will Expire on",
        firstAidTraining: "First Aid Training Received",
        attachment: "Attachment(First Aid Cert)",
        existingFacilities: "(D) Existing Facilities",
        toiletPans: "(i) No. of children toilet pans",
        washBasins: "(ii) No. of children-size wash basins",
        urinalTroughs: "(iii) No. of urinal troughs/bowls",
        tips: "use a “slash” to separate the two figures",
        remarks:
            "I understand that I have to employ sufficient number of child care staff/teaching staff and provide such provisions and facilities as required by the Child Care Services Regulations, the Operation Manual for Pre-primary Institution as well as the Education Regulations.",
        Remarks: "(E) Remarks",
        operatorType: "Operator/Centre Supervisor/Kindergarten Principal",
        operatorName: "Name of {{type}}",
        telNo: "Tel. No.",
        statement:
            "I would like to apply for adjustmentin capacity in my KG-cum-CCC／CCC Section of KG-cum-CCC and particulars of which are as follows:-",
    },
    tooltip: {
        tipOne: "Each urinal trough should not be less than 450mm in length",
    },
    notes: {
        pographySeven_url: "jokc@edb.gov.hk",
        termsConditions:
            "I have read, understood and agreed to the above terms and conditions.",
        dot: ".",
    },
    table: {
        ageRange: "Age range",
        fullDay: "Full Day",
        am: "AM",
        pm: "PM",
        existingZeroTwoYears: "0-2 years",
        existingTwoThreeYears: "2-3 years",
        existingTwoSixYears: "2-6 years",
        proposedZeroTwoYears: "0-2 years",
        proposedTwoThreeYears: "2-3 years",
        proposedTwoSixYears: "2-6 years",
        tooltip0To999: "0-999",
    },
    errorMsg: {
        specify: "specify",
        E0015: "No. of children toilet pans is required",
        E0016: "No. of children-size wash basins is required",
        E0017: "No. of urinal troughs/bowls is required",
        E0018: "Please checked",
        E0026: "Total of (i), (ii) and (iii) must be greater than 0",
        E0028: "The maximum value is 200",
        E0029: "Total max capacity must be greater than 0",
        existingTotal:
            "Total Existing Approved Capacity must be greater than 0",
        proposedTotal:
            "Total Proposed Capacity after Adjustment must be greater than 0",
        E0031: "Incorrect format",
        E0032: "Must fill in one of your HKID No. and Passport No.",
        E0033: "Must fill in one of your CCS Inclusion No. and CCW Inclusion No.",
        E0034: "The minimum value of each item is 0 and the maximum value is 99",
        atLeastOne: "At least one staff must have received First Aid Training",
        atLeast: "Please fill in at least one No.",
        existingMsg:
            "The total number of the same age range in the (ii) Existing Approved Capacity must be smaller or equal to the number of the same age range in (i) Maximum Capacity.",
        proposedMsg:
            "The total number of the same age range in the (iii) Proposed Capacity after Adjustment must be smaller or equal to the number of the same age range in (i) Maximum Capacity.",
        afterToday:
            "The expiry date of the First Aid Certificate must be after today",
        isExistingMsgEmpty:
            "If the (i) Maximum Capacity is blank, the (ii) Existing Approved Capacity in the same age range must be blank",
        isProposedMsgEmpty:
            "If the (i) Maximum Capacity is blank, the (iii) Proposed Capacity after Adjustment in the same age range must be blank",
    },
    submittedDialog: {
        text1: "You have successfully submitted the form. Please note that this form is not yet received by EDB. It is pending school approval.",
        text2: "You have successfully submitted the form. Please note that this form is not yet received by EDB. It is pending review from the  EDB.",
    },
};
export default Form040EN;
